import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import "@/App.css";

import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFab } from "@/components/layout/WhatsAppFab";
import { ScrollToTop } from "@/components/layout/ScrollToTop";

import Home from "@/pages/Home";
import Kurumsal from "@/pages/Kurumsal";
import Hizmetler from "@/pages/Hizmetler";
import HizmetDetay from "@/pages/HizmetDetay";
import Cozumler from "@/pages/Cozumler";
import Projeler from "@/pages/Projeler";
import Iletisim from "@/pages/Iletisim";
import KVKKAydinlatma from "@/pages/KVKKAydinlatma";
import GizlilikPolitikasi from "@/pages/GizlilikPolitikasi";
import CerezPolitikasi from "@/pages/CerezPolitikasi";
import NotFound from "@/pages/NotFound";

function SiteLayout() {
  return (
    <>
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <WhatsAppFab />
    </>
  );
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.1, smoothWheel: true }}>
      <BrowserRouter>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Routes>
            <Route element={<SiteLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/kurumsal" element={<Kurumsal />} />
              <Route path="/hizmetler" element={<Hizmetler />} />
              <Route path="/hizmetler/:slug" element={<HizmetDetay />} />
              <Route path="/cozumler" element={<Cozumler />} />
              <Route path="/projeler" element={<Projeler />} />
              <Route path="/iletisim" element={<Iletisim />} />
              <Route path="/kvkk-aydinlatma-metni" element={<KVKKAydinlatma />} />
              <Route path="/gizlilik-politikasi" element={<GizlilikPolitikasi />} />
              <Route path="/cerez-politikasi" element={<CerezPolitikasi />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
